var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "warehousing-detail" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            "label-position": "right",
            "show-message": false
          }
        },
        [
          _c("el-collapse", { attrs: { value: _vm.collapse } }, [
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "90%", "min-width": "1200px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.JobNumberInformation")))
                ]),
                _c(
                  "div",
                  {
                    staticClass: "form-row",
                    staticStyle: { display: "flex", "flex-direction": "row" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "right",
                          disabled: true
                        }
                      },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "section",
                            staticStyle: {
                              "flex-direction": "row",
                              width: "90%",
                              "min-width": "1200px"
                            },
                            attrs: { disabled: true }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  width: "64px"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("FbaJob.ValueAddedServices")
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.selectedLocalAddedService,
                                  callback: function($$v) {
                                    _vm.selectedLocalAddedService = $$v
                                  },
                                  expression: "selectedLocalAddedService"
                                }
                              },
                              [
                                _vm._l(_vm.localAddedService, function(item) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: item.code,
                                      staticStyle: {
                                        "margin-left": "8px",
                                        "margin-right": "8px"
                                      },
                                      attrs: { label: item.code }
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.chineseName) + " "
                                      )
                                    ]
                                  )
                                }),
                                _c(
                                  "el-checkbox",
                                  {
                                    staticStyle: {
                                      "margin-left": "8px",
                                      "margin-right": "8px"
                                    },
                                    attrs: { no: "destinationPortService" },
                                    model: {
                                      value: _vm.form.destinationPortService,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "destinationPortService",
                                          $$v
                                        )
                                      },
                                      expression: "form.destinationPortService"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SeaExport.PortOfDestinationServices"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.BusinessNo"),
                                      prop: "jobNo"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "jobNo" },
                                      model: {
                                        value: _vm.form.jobNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "jobNo", $$v)
                                        },
                                        expression: "form.jobNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_Destination"
                                      ),
                                      prop: "warehouseCode"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: _vm.form.warehouseCode,
                                              placement: "bottom-end"
                                            }
                                          },
                                          [
                                            _c("el-cascader", {
                                              staticStyle: {
                                                width: "91px",
                                                "padding-right": "2px"
                                              },
                                              attrs: {
                                                no: "warehouseCode",
                                                options: _vm.destinations,
                                                filterable: "",
                                                clearable: true
                                              },
                                              on: {
                                                focus: function($event) {
                                                  return _vm.JobUtils.focusWarehouseCode(
                                                    _vm.form
                                                  )
                                                },
                                                blur: function($event) {
                                                  return _vm.JobUtils.blurWarehouseCode(
                                                    _vm.form
                                                  )
                                                },
                                                change: function(p) {
                                                  _vm.JobUtils.warehouseCodeHandler(
                                                    _vm.form,
                                                    p
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.form.warehouseCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "warehouseCode",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.warehouseCode"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-checkbox",
                                          {
                                            attrs: { no: "remoteWarehouse" },
                                            model: {
                                              value: _vm.form.remoteWarehouse,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "remoteWarehouse",
                                                  $$v
                                                )
                                              },
                                              expression: "form.remoteWarehouse"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Warehouse.RemoteWarehouse"
                                                )
                                              ) + " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.OverseasWarehouse"
                                      )
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        no: "overseaWarehouseCode",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_OverseaWarehouse,
                                        filterable: "",
                                        "method-params": { ifFba: false },
                                        clearable: false,
                                        "tag-name": "countryChineseName",
                                        "tag-value": "warehouseCode",
                                        "default-value":
                                          _vm.form.overseaWarehouseCode
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.overseaWarehouseCode =
                                            p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.ConsignationCompany"
                                      ),
                                      prop: "customerId"
                                    }
                                  },
                                  [
                                    _c("cargo-company-select", {
                                      staticClass: "shipper-selector",
                                      staticStyle: { flex: "1" },
                                      attrs: {
                                        no: "customerId",
                                        "popper-class":
                                          "shipper-selector-popper",
                                        "method-params": {
                                          customer: true,
                                          active: true
                                        },
                                        "check-credit": true,
                                        job: _vm.form,
                                        "default-value":
                                          _vm.form.customerId || ""
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.DestinationCountry"
                                      ),
                                      prop: "destinationCountry"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "destinationCountry" },
                                      model: {
                                        value: _vm.form.country,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "country", $$v)
                                        },
                                        expression: "form.country"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("FbaJob.ChargingMethod")
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.form.chargingMethod,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "chargingMethod",
                                              $$v
                                            )
                                          },
                                          expression: "form.chargingMethod"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "0" } },
                                          [_vm._v(_vm._s("KG"))]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "1" } },
                                          [_vm._v(_vm._s("CBM"))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.PoOriginalOrderNo"
                                      ),
                                      prop: "poNumber"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "poNumber" },
                                      model: {
                                        value: _vm.form.poNumber,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "poNumber", $$v)
                                        },
                                        expression: "form.poNumber"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.ZIP"),
                                      prop: "zip"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "zip" },
                                      model: {
                                        value: _vm.form.zipCode,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "zipCode", $$v)
                                        },
                                        expression: "form.zipCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "FbaChannel.bubbleCountingRatio"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.form.bubbleCountingRatio,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "bubbleCountingRatio",
                                            $$v
                                          )
                                        },
                                        expression: "form.bubbleCountingRatio"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.ServiceChannel"),
                                      prop: "serviceChannel"
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        no: "serviceChannel",
                                        disabled: "",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_FbaChannel,
                                        filterable: "",
                                        clearable: true,
                                        "default-value": _vm.form.serviceChannel
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.serviceChannel = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.DestinationDeliveryMethod"
                                      ),
                                      prop: "deliveryMethod"
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        no: "destinationDistribution",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES,
                                        filterable: "",
                                        clearable: false,
                                        "default-value":
                                          _vm.form.destinationDistribution
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.destinationDistribution =
                                            p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "FbaJob.BubbleSplittingRatio"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        "controls-position": "right",
                                        max: 100,
                                        min: 0,
                                        precision: 0
                                      },
                                      model: {
                                        value: _vm.form.bubbleSplittingRatio,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "bubbleSplittingRatio",
                                            $$v
                                          )
                                        },
                                        expression: "form.bubbleSplittingRatio"
                                      }
                                    }),
                                    _vm._v("% ")
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Pricing.TransportMode"),
                                      prop: "shippingType"
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        no: "shippingType",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .local_cache_FbaJobConstants$SHIPPING_TYPES,
                                        filterable: "",
                                        clearable: false,
                                        "default-value": _vm.form.shippingType
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.shippingType = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm.form.destinationDistribution &&
                                Number(_vm.form.destinationDistribution) === 1
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "Warehouse.CourierServicesCompany"
                                          ),
                                          prop: "courierServicesCompany"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              no: "expressCompany",
                                              placeholder: "",
                                              clearable: ""
                                            },
                                            model: {
                                              value: _vm.form.expressCompany,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "expressCompany",
                                                  $$v
                                                )
                                              },
                                              expression: "form.expressCompany"
                                            }
                                          },
                                          _vm._l(
                                            _vm.FbaJobConstants
                                              .EXPRESS_COMPANYS,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.code,
                                                attrs: {
                                                  label: item.chineseName,
                                                  value: item.code
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "90%", "min-width": "1200px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.WarehouseInformation")))
                ]),
                _c(
                  "div",
                  {
                    staticClass: "form-row",
                    staticStyle: { display: "flex", "flex-direction": "row" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "110px",
                          "label-position": "right"
                        }
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "required",
                                    attrs: {
                                      label: _vm.$t("Warehouse.WarehouseNo"),
                                      prop: "warehouseNo"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        disabled: !(
                                          _vm.isEditing &&
                                          !_vm.form.checklistTime
                                        )
                                      },
                                      on: {
                                        change: _vm.warehouseNoChargeHandler
                                      },
                                      model: {
                                        value: _vm.form.warehouseNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "warehouseNo", $$v)
                                        },
                                        expression: "form.warehouseNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("Warehouse.ReceiptNo"),
                                      prop: "receiptNo"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.form.receiptNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "receiptNo", $$v)
                                        },
                                        expression: "form.receiptNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width required",
                                    attrs: {
                                      label: _vm.$t("Warehouse.WarehouseName"),
                                      prop: "warehouse"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.form.warehouse,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "warehouse", $$v)
                                        },
                                        expression: "form.warehouse"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("Warehouse.Warehouseman"),
                                      prop: "warehouseOp"
                                    }
                                  },
                                  [
                                    _c("cargo-user-select", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        "method-params": {
                                          officeId: _vm.form.opOffice,
                                          category: "role",
                                          shape: "warehouseOp"
                                        },
                                        "default-value":
                                          _vm.form.warehouseOp || "",
                                        disabled: !_vm.isEditing
                                      },
                                      on: {
                                        change: function(p) {
                                          _vm.form.warehouseOp = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.WarehouseLocation"
                                      ),
                                      prop: "location"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.form.location,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "location", $$v)
                                        },
                                        expression: "form.location"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "required",
                                    attrs: {
                                      label: _vm.$t("Warehouse.StorageDate"),
                                      prop: "warehouseInDate"
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        type: "datetime",
                                        disabled: !_vm.isEditing,
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm"
                                      },
                                      model: {
                                        value: _vm.form.warehouseInDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "warehouseInDate",
                                            $$v
                                          )
                                        },
                                        expression: "form.warehouseInDate"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("Warehouse.DeliveryDate"),
                                      prop: "warehouseOutDate"
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        type: "datetime",
                                        disabled: "",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm"
                                      },
                                      model: {
                                        value: _vm.form.warehouseOutDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "warehouseOutDate",
                                            $$v
                                          )
                                        },
                                        expression: "form.warehouseOutDate"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("Warehouse.DeliveryMode"),
                                      prop: "outType"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "95%" },
                                        attrs: {
                                          clearable: "",
                                          disabled: "",
                                          placeholder: _vm.$t(
                                            "Message.PleaseSelect"
                                          ),
                                          size: "mini"
                                        },
                                        model: {
                                          value: _vm.form.outType,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "outType", $$v)
                                          },
                                          expression: "form.outType"
                                        }
                                      },
                                      _vm._l(
                                        _vm.WarehouseInState
                                          .WAREHOUSE_IN_OUT_TYPE,
                                        function(item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label:
                                                _vm.$store.getters.language ===
                                                "zh"
                                                  ? item.chineseName
                                                  : item.englishName,
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "isPallet" } },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: { disabled: !_vm.isEditing },
                                        on: {
                                          change:
                                            _vm.daycareInformationChangeHandler
                                        },
                                        model: {
                                          value: _vm.form.pallet,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "pallet", $$v)
                                          },
                                          expression: "form.pallet"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "Warehouse.DaycareInformation"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "isSealCargo" } },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: { disabled: !_vm.isEditing },
                                        model: {
                                          value: _vm.form.sealCargo,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "sealCargo", $$v)
                                          },
                                          expression: "form.sealCargo"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Warehouse.IsTheGoodsClosed")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.PalletSum"),
                                      prop: "palletSum"
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        disabled: true,
                                        "controls-position": "right",
                                        max: 10,
                                        min: 0,
                                        precision: 0
                                      },
                                      model: {
                                        value: _vm.form.palletSum,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "palletSum", $$v)
                                        },
                                        expression: "form.palletSum"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.DeliveryCmp"),
                                      prop: "DeliveryCmp"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.form.deliveryCmp,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "deliveryCmp", $$v)
                                        },
                                        expression: "form.deliveryCmp"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.LicensePlate"),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.form.truckNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "truckNo", $$v)
                                        },
                                        expression: "form.truckNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.Driver"),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.form.driver,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "driver", $$v)
                                        },
                                        expression: "form.driver"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.DriverPhone"),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.form.driverTel,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "driverTel", $$v)
                                        },
                                        expression: "form.driverTel"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.Remark"),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "custom-textarea",
                                      staticStyle: {
                                        width: "95%",
                                        height: "64px"
                                      },
                                      attrs: {
                                        type: "textarea",
                                        row: 3,
                                        disabled: !_vm.isEditing
                                      },
                                      model: {
                                        value: _vm.form.remarks,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "remarks", $$v)
                                        },
                                        expression: "form.remarks"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "isBroken" } },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: { disabled: !_vm.isEditing },
                                        on: {
                                          change: _vm.checkboxChangeHandler
                                        },
                                        model: {
                                          value: _vm.form.broken,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "broken", $$v)
                                          },
                                          expression: "form.broken"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Warehouse.IsNotComputationIsAffectedByDampness"
                                            )
                                          ) + " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "receiveDc" } },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: { disabled: !_vm.isEditing },
                                        model: {
                                          value: _vm.form.receiveDc,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "receiveDc", $$v)
                                          },
                                          expression: "form.receiveDc"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Warehouse.ReceiveDc")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.ComputationIsAffectedByDampnessNum"
                                      ),
                                      prop: "brokenNum"
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        min: 0,
                                        max: 99999,
                                        "controls-position": "right",
                                        precision: 0,
                                        disabled: !(
                                          _vm.isEditing && _vm.form.broken
                                        )
                                      },
                                      model: {
                                        value: _vm.form.brokenQuantity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "brokenQuantity",
                                            $$v
                                          )
                                        },
                                        expression: "form.brokenQuantity"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.DescriptionOfGoods"
                                      ),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "custom-textarea",
                                      staticStyle: {
                                        width: "95%",
                                        height: "64px"
                                      },
                                      attrs: {
                                        type: "textarea",
                                        row: 3,
                                        disabled: !_vm.isEditing
                                      },
                                      model: {
                                        value: _vm.form.brokenDes,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "brokenDes", $$v)
                                        },
                                        expression: "form.brokenDes"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.HandlingOpinions"
                                      ),
                                      prop: "licensePlate"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "custom-textarea",
                                      staticStyle: {
                                        width: "95%",
                                        height: "64px"
                                      },
                                      attrs: {
                                        type: "textarea",
                                        row: 3,
                                        disabled: !(
                                          _vm.isEditing &&
                                          (_vm.isChecklist || _vm.isWeigh)
                                        )
                                      },
                                      model: {
                                        value: _vm.form.comments,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "comments", $$v)
                                        },
                                        expression: "form.comments"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.SealingWeight"),
                                      prop: "brokenNum"
                                    }
                                  },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        min: 0,
                                        max: 999999999999,
                                        "controls-position": "right",
                                        precision: 1,
                                        disabled: !(
                                          _vm.isEditing && _vm.form.sealCargo
                                        )
                                      },
                                      model: {
                                        value: _vm.form.sealWeight,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "sealWeight", $$v)
                                        },
                                        expression: "form.sealWeight"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _vm.form.labeling
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "Warehouse.LabelingTime"
                                          ),
                                          prop: "LabelingTime"
                                        }
                                      },
                                      [
                                        _c("el-date-picker", {
                                          staticStyle: { width: "95%" },
                                          attrs: {
                                            type: "datetime",
                                            disabled: !_vm.isEditing,
                                            "value-format":
                                              "yyyy-MM-dd HH:mm:ss",
                                            format: "yyyy-MM-dd HH:mm"
                                          },
                                          model: {
                                            value: _vm.form.labelingTime,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "labelingTime",
                                                $$v
                                              )
                                            },
                                            expression: "form.labelingTime"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.WeighTime"),
                                      prop: "WeighTime"
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        type: "datetime",
                                        disabled: !(
                                          _vm.isEditing && _vm.isWeigh
                                        ),
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm"
                                      },
                                      model: {
                                        value: _vm.form.weighTime,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "weighTime", $$v)
                                        },
                                        expression: "form.weighTime"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.ChecklistTime"),
                                      prop: "checklistTime"
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        type: "datetime",
                                        disabled: !(
                                          _vm.isEditing &&
                                          (_vm.isChecklist || _vm.isWeigh)
                                        ),
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm"
                                      },
                                      model: {
                                        value: _vm.form.checklistTime,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "checklistTime",
                                            $$v
                                          )
                                        },
                                        expression: "form.checklistTime"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.ChecklistResult"
                                      ),
                                      prop: "checklistResult"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "95%" },
                                        attrs: {
                                          no: "checklistStatus",
                                          clearable: "",
                                          placeholder: "",
                                          disabled: !(
                                            _vm.isEditing &&
                                            (_vm.isChecklist || _vm.isWeigh)
                                          )
                                        },
                                        model: {
                                          value: _vm.form.checklistStatus,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "checklistStatus",
                                              $$v
                                            )
                                          },
                                          expression: "form.checklistStatus"
                                        }
                                      },
                                      _vm._l(
                                        _vm.SystemConstants.CHECKLIST_STATUS,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.chineseName,
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.FaceOrderPrintTime"
                                      ),
                                      prop: "faceOrderPrintTime"
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        type: "datetime",
                                        disabled: "",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm"
                                      },
                                      model: {
                                        value: _vm.form.faceOrderPrintTime,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "faceOrderPrintTime",
                                            $$v
                                          )
                                        },
                                        expression: "form.faceOrderPrintTime"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("Warehouse.CourierNumber"),
                                      prop: "courierNumber"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.courierNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "courierNumber",
                                            $$v
                                          )
                                        },
                                        expression: "form.courierNumber"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 4.8 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SpecialGoods.StuffingTime"
                                      ),
                                      prop: "packingTime"
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        type: "datetime",
                                        disabled: true,
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm"
                                      },
                                      model: {
                                        value: _vm.form.packingTime,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "packingTime", $$v)
                                        },
                                        expression: "form.packingTime"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("Warehouse.RefContainerNo"),
                                      prop: "refContainerNo"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "95%" },
                                      attrs: { disabled: true },
                                      model: {
                                        value: _vm.form.refContainerNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "refContainerNo",
                                            $$v
                                          )
                                        },
                                        expression: "form.refContainerNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "Warehouse.ReturnGoodsTime"
                                      ),
                                      prop: "returnGoodsTime"
                                    }
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "95%" },
                                      attrs: {
                                        type: "datetime",
                                        disabled: "",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm"
                                      },
                                      model: {
                                        value: _vm.form.returnGoodsTime,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "returnGoodsTime",
                                            $$v
                                          )
                                        },
                                        expression: "form.returnGoodsTime"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("Warehouse.ReturnReason"),
                                      prop: "returnReason"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "custom-textarea",
                                      staticStyle: {
                                        width: "95%",
                                        height: "64px"
                                      },
                                      attrs: {
                                        type: "textarea",
                                        row: 3,
                                        disabled: ""
                                      },
                                      model: {
                                        value: _vm.form.returnReason,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "returnReason",
                                            $$v
                                          )
                                        },
                                        expression: "form.returnReason"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "90%", "min-width": "1200px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("Warehouse.CargoDetails") +
                        "(" +
                        this.$t("CargoMsg.Cargo_Consignation") +
                        ")"
                    )
                  )
                ]),
                _c(
                  "div",
                  {
                    staticClass: "form-row grid-list",
                    staticStyle: { "min-width": "1200px" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "left",
                          disabled: !_vm.isEditing
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-form",
                              { staticClass: "spacing" },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.jobGoodsViewType,
                                      callback: function($$v) {
                                        _vm.jobGoodsViewType = $$v
                                      },
                                      expression: "jobGoodsViewType"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      { attrs: { label: "detail" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Warehouse.Detail"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-radio",
                                      { attrs: { label: "summary" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Warehouse.Summary"))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            !_vm.jobGoodsViewSummary
                              ? _c("cargo-ag-grid", {
                                  ref: "goodsDetailTableEst",
                                  staticStyle: { height: "200px" },
                                  attrs: {
                                    "config-module": "9300008",
                                    "grid-options":
                                      _vm.detailList.goodGridOptionsEst,
                                    "column-defs":
                                      _vm.dynamicGoodsColumnEstDefs,
                                    "row-data": _vm.form.fbaJobGoods || []
                                  },
                                  on: {
                                    gridReady: function(params) {
                                      _vm.detailList.gridApiEst = params.api
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm.jobGoodsViewSummary
                              ? _c("cargo-ag-grid", {
                                  ref: "goodsSummaryTableEst",
                                  staticStyle: { height: "200px" },
                                  attrs: {
                                    "config-module": "9300020",
                                    "grid-options":
                                      _vm.detailList.goodGridOptionsEst,
                                    "column-defs":
                                      _vm.dynamicGoodsColumnEstDefs,
                                    "row-data":
                                      _vm.summaryJobGoodsDetailList || []
                                  },
                                  on: {
                                    gridReady: function(params) {
                                      _vm.detailList.gridApiEst = params.api
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "90%", "min-width": "1200px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("Warehouse.CargoDetails") +
                        "(" +
                        this.$t("SeaExport.Actual") +
                        ")"
                    )
                  )
                ]),
                _c(
                  "div",
                  {
                    staticClass: "form-row grid-list",
                    staticStyle: { "min-width": "1200px" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "left",
                          disabled: !_vm.isEditing
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-form",
                              { staticClass: "spacing" },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.goodsViewType,
                                      callback: function($$v) {
                                        _vm.goodsViewType = $$v
                                      },
                                      expression: "goodsViewType"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      { attrs: { label: "detail" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Warehouse.Detail"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-radio",
                                      { attrs: { label: "summary" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Warehouse.Summary"))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            !_vm.fbaLob
                              ? _c(
                                  "el-form",
                                  { staticClass: "spacing" },
                                  [
                                    !_vm.goodsViewSummary
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              disabled:
                                                _vm.hasChecklistTime ||
                                                !_vm.isEditing
                                            },
                                            on: { click: _vm.addDetailHandler }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("Warehouse.AddCargo")
                                              ) + " "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          disabled:
                                            _vm.hasChecklistTime ||
                                            !_vm.isEditing
                                        },
                                        on: { click: _vm.batchMaintenance }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Warehouse.BatchMaintenance")
                                          ) + " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown",
                                      {
                                        staticStyle: {
                                          margin: "0 5px",
                                          "font-size": "12px"
                                        },
                                        attrs: { no: "14" }
                                      },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                              "margin-left": "5px"
                                            },
                                            attrs: {
                                              action: _vm.actionOrderUrl,
                                              headers: _vm.headers,
                                              "show-file-list": false,
                                              accept: ".xls, .xlsx",
                                              "before-upload":
                                                _vm.beforeOrderUpload,
                                              "on-success":
                                                _vm.uploadOrderSuccess,
                                              "on-error": _vm.handleError,
                                              data: {
                                                uuid: _vm.warehouseInUuid,
                                                type: "GN"
                                              },
                                              disabled:
                                                _vm.hasChecklistTime ||
                                                _vm.isEditing
                                            }
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  disabled:
                                                    _vm.hasChecklistTime ||
                                                    _vm.isEditing
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Import2"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-arrow-down el-icon--right"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown"
                                          },
                                          [
                                            _c(
                                              "el-dropdown-item",
                                              { attrs: { command: 1 } },
                                              [
                                                _c(
                                                  "el-upload",
                                                  {
                                                    ref: "uploadOrder",
                                                    staticStyle: {
                                                      display: "inline-block"
                                                    },
                                                    attrs: {
                                                      action:
                                                        _vm.actionOrderUrl,
                                                      headers: _vm.headers,
                                                      "show-file-list": false,
                                                      accept: ".xls, .xlsx",
                                                      "before-upload":
                                                        _vm.beforeOrderUpload,
                                                      "on-success":
                                                        _vm.uploadOrderSuccess,
                                                      "on-error":
                                                        _vm.handleError,
                                                      data: {
                                                        uuid:
                                                          _vm.warehouseInUuid,
                                                        type: "GN"
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticStyle: {
                                                          "padding-left": "0px",
                                                          color: "#6F6F6F",
                                                          "text-align": "left",
                                                          width: "80px"
                                                        },
                                                        attrs: {
                                                          slot: "trigger",
                                                          type: "text"
                                                        },
                                                        slot: "trigger"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "CargoMsg.GOODS_INFO_IMPORT"
                                                            )
                                                          ) + " "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticStyle: {
                                                      "padding-left": "0px",
                                                      color: "#6F6F6F",
                                                      "text-align": "left",
                                                      width: "80px"
                                                    },
                                                    attrs: {
                                                      no: "16",
                                                      type: "text"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.downLoadDetail()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "CargoMsg.Cargo_DownLoad_Detail"
                                                        )
                                                      ) + " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticStyle: {
                                                      "padding-left": "0px",
                                                      color: "#6F6F6F",
                                                      "text-align": "left",
                                                      width: "80px"
                                                    },
                                                    attrs: {
                                                      no: "17",
                                                      type: "text"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.downLoadSummary()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "CargoMsg.Cargo_DownLoad_Summary"
                                                        )
                                                      ) + " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          disabled:
                                            _vm.hasChecklistTime ||
                                            !_vm.isEditing
                                        },
                                        on: { click: _vm.pickingGoods }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Warehouse.PickingGoods")
                                          ) + " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "danger",
                                          disabled:
                                            !_vm.isEditing ||
                                            _vm.hasChecklistTime
                                        },
                                        on: { click: _vm.clearData }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("CargoMsg.Cargo_Empty")
                                          ) + " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "danger",
                                          disabled:
                                            _vm.hasChecklistTime ||
                                            !_vm.isEditing
                                        },
                                        on: { click: _vm.delDetailHandler }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Warehouse.DeleteCargo")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-form",
                              { staticClass: "spacing" },
                              [
                                _vm.fbaLob &&
                                ((_vm.source === "fbaSea" &&
                                  _vm.$checkPermission([
                                    "button_FBABookingNew_fbaSeaVerifyWarehouse"
                                  ])) ||
                                  (_vm.source === "fbaAir" &&
                                    _vm.$checkPermission([
                                      "button_FBAAeBooking_fbaSeaVerifyWarehouse"
                                    ])) ||
                                  (_vm.source === "fbaRailway" &&
                                    _vm.$checkPermission([
                                      "button_FBARailwayExport_fbaRailVerifyWarehouse"
                                    ])))
                                  ? _c(
                                      "el-button",
                                      {
                                        staticStyle: { "margin-left": "10px" },
                                        attrs: {
                                          type: "primary",
                                          disabled: !(
                                            _vm.action === "look" &&
                                            !_vm.form.checklistTime &&
                                            _vm.form.warehouseInDetailList &&
                                            _vm.form.warehouseInDetailList
                                              .length > 0
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onCheckList()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Warehouse.Checklist")
                                          ) + " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "el-form",
                              { attrs: { disabled: !!_vm.form.checklistTime } },
                              [
                                !_vm.goodsViewSummary
                                  ? _c("cargo-ag-grid", {
                                      ref: "goodsDetailTable",
                                      staticStyle: { height: "200px" },
                                      attrs: {
                                        "config-module": "9300009",
                                        "grid-options":
                                          _vm.detailList.goodGridOptions,
                                        "column-defs":
                                          _vm.dynamicGoodsColumnDefs,
                                        "row-data":
                                          _vm.form.warehouseInDetailList || []
                                      },
                                      on: {
                                        gridReady: function(params) {
                                          _vm.detailList.gridApi = params.api
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm.goodsViewSummary
                                  ? _c("cargo-ag-grid", {
                                      ref: "goodsSummaryDTable",
                                      staticStyle: { height: "200px" },
                                      attrs: {
                                        "config-module": "9300010",
                                        "grid-options":
                                          _vm.detailList.goodGridOptions,
                                        "column-defs":
                                          _vm.dynamicGoodsColumnDefs,
                                        "row-data":
                                          _vm.summaryGoodsDetailList || []
                                      },
                                      on: {
                                        gridReady: function(params) {
                                          _vm.detailList.gridApi = params.api
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c("el-form-item", { staticClass: "auto-width" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "title-row",
                                  staticStyle: {
                                    display: "flex",
                                    "text-align": "left"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "100px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("SeaExport.Quantity")) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "170px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("SeaExport.Weight2")) +
                                          " KGS "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "150px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("SeaExport.Cubage")) +
                                          " CBM "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "150px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("SeaExport.VolumetricWeight")
                                          ) +
                                          " KGS "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                        color: "#404144",
                                        "white-space": "nowrap",
                                        width: "170px",
                                        "text-align": "right"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("SeaExport.ChargedWeight")
                                          ) +
                                          " M/T "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: { label: _vm.$t("SeaExport.Actual") }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.quantitySum,
                                      expression: "form.quantitySum"
                                    }
                                  ],
                                  style: {
                                    color:
                                      Number(_vm.form.quantitySum) ===
                                      Number(_vm.form.quantityContract)
                                        ? "black"
                                        : "red",
                                    minHeight: "28px",
                                    minLength: "104px",
                                    textAlign: "center"
                                  },
                                  attrs: { disabled: "" },
                                  domProps: { value: _vm.form.quantitySum },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "quantitySum",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.weightSum,
                                      expression: "form.weightSum"
                                    }
                                  ],
                                  style: {
                                    color:
                                      Number(_vm.form.weightSum) ===
                                      Number(_vm.form.weightContract)
                                        ? "black"
                                        : "red",
                                    minHeight: "28px",
                                    minLength: "104px",
                                    textAlign: "center"
                                  },
                                  attrs: { disabled: "" },
                                  domProps: { value: _vm.form.weightSum },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "weightSum",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.cubageSum,
                                      expression: "form.cubageSum"
                                    }
                                  ],
                                  style: {
                                    color:
                                      Number(_vm.form.cubageSum) ===
                                      Number(_vm.form.cubageContract)
                                        ? "black"
                                        : "red",
                                    minHeight: "28px",
                                    minLength: "104px",
                                    textAlign: "center"
                                  },
                                  attrs: { disabled: "" },
                                  domProps: { value: _vm.form.cubageSum },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "cubageSum",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.volumetricWeightAct,
                                      expression: "form.volumetricWeightAct"
                                    }
                                  ],
                                  style: {
                                    color:
                                      Number(_vm.form.volumetricWeightAct) ===
                                      Number(_vm.form.volumetricWeightContract)
                                        ? "black"
                                        : "red",
                                    minHeight: "28px",
                                    minLength: "104px",
                                    textAlign: "center"
                                  },
                                  attrs: { disabled: "" },
                                  domProps: {
                                    value: _vm.form.volumetricWeightAct
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "volumetricWeightAct",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.chargeWeightAct,
                                      expression: "form.chargeWeightAct"
                                    }
                                  ],
                                  style: {
                                    color:
                                      Number(_vm.form.chargeWeightAct) ===
                                      Number(_vm.form.chargeWeightContract)
                                        ? "black"
                                        : "red",
                                    minHeight: "28px",
                                    minLength: "104px",
                                    textAlign: "center"
                                  },
                                  attrs: { disabled: !_vm.isEditing },
                                  domProps: { value: _vm.form.chargeWeightAct },
                                  on: {
                                    change: _vm.chargeWeightActChange,
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "chargeWeightAct",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: {
                                  label: _vm.$t("SeaExport.Consignation")
                                }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.quantityContract,
                                      expression: "form.quantityContract"
                                    }
                                  ],
                                  style: {
                                    color:
                                      Number(_vm.form.quantitySum) ===
                                      Number(_vm.form.quantityContract)
                                        ? "black"
                                        : "red",
                                    minHeight: "28px",
                                    minLength: "104px",
                                    textAlign: "center"
                                  },
                                  attrs: { disabled: "" },
                                  domProps: {
                                    value: _vm.form.quantityContract
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "quantityContract",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.weightContract,
                                      expression: "form.weightContract"
                                    }
                                  ],
                                  style: {
                                    color:
                                      Number(_vm.form.weightSum) ===
                                      Number(_vm.form.weightContract)
                                        ? "black"
                                        : "red",
                                    minHeight: "28px",
                                    minLength: "104px",
                                    textAlign: "center"
                                  },
                                  attrs: { disabled: "" },
                                  domProps: { value: _vm.form.weightContract },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "weightContract",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.cubageContract,
                                      expression: "form.cubageContract"
                                    }
                                  ],
                                  style: {
                                    color:
                                      Number(_vm.form.cubageSum) ===
                                      Number(_vm.form.cubageContract)
                                        ? "black"
                                        : "red",
                                    minHeight: "28px",
                                    minLength: "104px",
                                    textAlign: "center"
                                  },
                                  attrs: { disabled: "" },
                                  domProps: { value: _vm.form.cubageContract },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "cubageContract",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.volumetricWeightContract,
                                      expression:
                                        "form.volumetricWeightContract"
                                    }
                                  ],
                                  style: {
                                    color:
                                      Number(_vm.form.volumetricWeightAct) ===
                                      Number(_vm.form.volumetricWeightContract)
                                        ? "black"
                                        : "red",
                                    minHeight: "28px",
                                    minLength: "104px",
                                    textAlign: "center"
                                  },
                                  attrs: { disabled: "" },
                                  domProps: {
                                    value: _vm.form.volumetricWeightContract
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "volumetricWeightContract",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.chargeWeightContract,
                                      expression: "form.chargeWeightContract"
                                    }
                                  ],
                                  style: {
                                    color:
                                      Number(_vm.form.chargeWeightAct) ===
                                      Number(_vm.form.chargeWeightContract)
                                        ? "black"
                                        : "red",
                                    minHeight: "28px",
                                    minLength: "104px",
                                    textAlign: "center"
                                  },
                                  attrs: { disabled: "" },
                                  domProps: {
                                    value: _vm.form.chargeWeightContract
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "chargeWeightContract",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "90%", "min-width": "1200px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.CargoPhotos")))
                ]),
                _c(
                  "div",
                  {
                    staticClass: "form-row grid-list",
                    staticStyle: { "min-width": "1200px" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "left",
                          disabled: !_vm.isEditing
                        }
                      },
                      [
                        !_vm.fbaLob
                          ? _c(
                              "el-form",
                              { staticClass: "spacing" },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "margin-right": "5px"
                                    },
                                    attrs: {
                                      action:
                                        _vm.URL.warehouseIn
                                          .uploadFileForWarehouseIn +
                                        "?warehouseInUuid=" +
                                        _vm.warehouseInUuid,
                                      headers: {
                                        sessionId: _vm.$store.getters.token
                                      },
                                      "show-file-list": false,
                                      "on-success": _vm.uploadSuccess,
                                      "on-change": _vm.toChooseFile,
                                      disabled: !_vm.isEditing
                                    }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          disabled: !_vm.isEditing
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Warehouse.SelectFile"))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "danger",
                                      disabled: !_vm.isEditing
                                    },
                                    on: { click: _vm.delPhotoHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Warehouse.DeleteFile")) +
                                        " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("cargo-ag-grid", {
                          ref: "photosList",
                          staticStyle: { height: "200px" },
                          attrs: {
                            "config-module": "9300013",
                            "grid-options": _vm.photoList.gridOptions,
                            "column-defs": _vm.photoList.photoColumn,
                            "row-data": _vm.form.businessDocumentVOList || []
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.photoList.gridApi = params.api
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { width: "90%", "min-width": "1200px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("Warehouse.OperationRequirements")))
                ]),
                _c(
                  "div",
                  {
                    staticClass: "form-row grid-list",
                    staticStyle: { "min-width": "1200px" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: {
                          "label-width": "100px",
                          "label-position": "left",
                          disabled: !_vm.isEditing
                        }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("cargo-ag-grid", {
                              ref: "opList",
                              staticStyle: { height: "200px" },
                              attrs: {
                                "config-module": "9300004",
                                "grid-options": _vm.opList.options,
                                "column-defs": _vm.opList.opColumn,
                                "row-data":
                                  _vm.form.operationRequirementVOList || []
                              },
                              on: {
                                gridReady: function(params) {
                                  _vm.opList.gridApi = params.api
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm.containerNoEditor.visible
        ? _c("container-no-editor", {
            attrs: {
              "boxes-number": _vm.containerNoEditor.boxesNumber,
              visible: _vm.containerNoEditor.visible,
              "shipment-id": _vm.containerNoEditor.shipmentId,
              source: _vm.goodsViewType,
              "container-no": _vm.containerNoEditor.containerNo,
              "warehouse-in-detail-list": _vm.form.warehouseInDetailList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.containerNoEditor, "visible", $event)
              },
              summarySaveCallBack: _vm.containerNoEditor.summarySaveCallBack,
              detailSaveCallBack: _vm.containerNoEditor.detailSaveCallBack,
              close: function($event) {
                _vm.containerNoEditor.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.fileTypeEditor.visible
        ? _c("mx-file-type-editor", {
            attrs: {
              visible: _vm.fileTypeEditor.visible,
              lob: _vm.fileTypeEditor.lob,
              "file-id": _vm.fileTypeEditor.fileId,
              "file-category": _vm.fileTypeEditor.fileCategory
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.fileTypeEditor, "visible", $event)
              },
              saveFileType: _vm.itemEditEndHandler
            }
          })
        : _vm._e(),
      _vm.jobNosWindow.visible
        ? _c("job-nos-window", {
            attrs: {
              visible: _vm.jobNosWindow.visible,
              "job-nos": _vm.jobNosWindow.jobs
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.jobNosWindow, "visible", $event)
              },
              selectJobNoHandler: _vm.selectJobNoHandler
            }
          })
        : _vm._e(),
      _vm.checklist.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.checklist.visible,
                title: _vm.$t("Warehouse.Checklist"),
                width: "340px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.checklist, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "85px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Warehouse.ChecklistTime") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "195px" },
                        attrs: {
                          no: "checklistTime",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm",
                          format: "yyyy-MM-dd HH:mm",
                          placeholder: _vm.$t("SeaExport.SelectTime")
                        },
                        model: {
                          value: _vm.checklist.checklistTime,
                          callback: function($$v) {
                            _vm.$set(_vm.checklist, "checklistTime", $$v)
                          },
                          expression: "checklist.checklistTime"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Warehouse.ChecklistResult") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "195px" },
                          attrs: { no: "checklistStatus", placeholder: "" },
                          model: {
                            value: _vm.checklist.checklistStatus,
                            callback: function($$v) {
                              _vm.$set(_vm.checklist, "checklistStatus", $$v)
                            },
                            expression: "checklist.checklistStatus"
                          }
                        },
                        _vm._l(_vm.SystemConstants.CHECKLIST_STATUS, function(
                          item
                        ) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.chineseName, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Warehouse.HandlingOpinions") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "195px" },
                        attrs: { type: "textarea", row: 5 },
                        model: {
                          value: _vm.checklist.comments,
                          callback: function($$v) {
                            _vm.$set(_vm.checklist, "comments", $$v)
                          },
                          expression: "checklist.comments"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.toChecklist }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.checklist.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.batchMaintenanceDialog.visible
        ? _c("batch-maintenance-dialog", {
            attrs: {
              visible: _vm.batchMaintenanceDialog.visible,
              "job-key": _vm.jobUuid,
              "exist-detail-list": _vm.form.warehouseInDetailList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchMaintenanceDialog, "visible", $event)
              },
              saveCallBack: _vm.batchMaintenanceDialog.saveCallBack,
              close: function($event) {
                _vm.batchMaintenanceDialog.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }